import { CommonModule } from '@angular/common';
import { Component, OnInit, Optional } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { ConversationListService } from '../../../../core/src/lib/state/conversation-list.service';
import { isMobile } from '../../../../core/src/lib/inbox-utils';
import { ConversationUIModule } from '../../conversation-ui.module';

@Component({
  selector: 'inbox-home',
  templateUrl: './inbox-home.component.html',
  styleUrls: ['./inbox-home.component.scss'],
  imports: [CommonModule, RouterModule, ConversationUIModule, GalaxyLoadingSpinnerModule],
})
export class InboxHomeComponent implements OnInit {
  readonly organizationHasConversations$ = this.conversationListService.organizationHasConversations$;

  constructor(
    @Optional() private readonly analyticsService: ProductAnalyticsService,
    private conversationListService: ConversationListService,
  ) {}

  ngOnInit(): void {
    if (this.analyticsService) {
      this.analyticsService.trackEvent('inbox', 'home', 'view');
    }
  }

  get isMobile(): boolean {
    return isMobile();
  }
}
